"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = encodeBase64;

var _browser = _interopRequireDefault(require("../../../constants/browser"));

/* istanbul ignore file */
// constants

/**
 * Converti une chaîne de caractère en base64.
 * @param {string} str
 */
function encodeBase64(str) {
  if (!_browser.default) {
    return Buffer.from(str).toString("base64");
  } else {
    return window.btoa(str);
  }
}